import React from 'react';
import Parent from "../parent";
import { withTranslation } from 'react-i18next';
import BackNextBar from './backNextBar';
import OneTimeSinglePayment from './oneTimeSinglePayment';
import {BllinkLogger} from '../utils/bllink_loggers';
import OneTimePaymentsLogic from './oneTimePaymentsLogic';
import { constants } from '../constants/constants';
import AllPaid from './allPaid';
import AddFastPayment from './fastOneTime/addFastPayment';

export class OneTimePaymentSection extends Parent {

    constructor(props) {
        super(props);

        BllinkLogger.info(`one time payments constructor props `, props);
        this.oneTimeInputChangedFunc = this.oneTimeSelectedChanged.bind(this);
        this.oneTimePaymentMethodChangedFunc = this.oneTimePaymentMethodChanged.bind(this);
        this.state = this.newState(props);
        this.state.isAdmin = false;
        BllinkLogger.info(`one time payments constructor state `, this.state);
    }

    async componentDidMount() {
        const isManager = await this.isLoggedIn();
        const isAdmin = await this.isAdmin();
        this.setState({
            isAdmin,
            isManager
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            BllinkLogger.info('componentDidUpdate OneTimePaymentSection ', this.props)
            this.setNewState(this.props);
        }
    }

    oneTimeSelectedChanged(e){
        /*

        */

        const paymentsSelected = OneTimePaymentsLogic.getCurrentSelectedStatus(this.state.payments);
        BllinkLogger.info(`on time paymentsSelected before caching  `, paymentsSelected.map(x=> x.selected))

        OneTimePaymentsLogic.saveToCache(
            paymentsSelected,
            this.state.buildingID,
            this.state.apartmentNumber
        )
        // to rerender the page
        this.setNewState(this.state)

    }

    oneTimePaymentMethodChanged(){
        // when the manager changes the method, it should change at all
        // invoking a simple refresh
        this.setState({

        })
    }

    setNewState(props){
        this.setState(this.newState(props));
    }

    newState(props) {

        props = props || {};
        const statePayments = (this.state || {}).payments;
        const payments = props.payments || statePayments || [];

        const paymentsFinal = OneTimePaymentsLogic.fetchFromCache(
            payments,
            props.buildingID,
            props.apartmentNumber
        )

        BllinkLogger.info(`payments final one time `, paymentsFinal)
        return {
            payments: paymentsFinal,
            buildingID: props.buildingID,
            apartmentNumber: props.apartmentNumber
        }
    }


    renderPayments() {
        return (
            this.state.payments.map((value, index) => {
                return (
                    <OneTimeSinglePayment
                        payment={value}
                        index={index}
                        key={index}
                        onChangeFunc={this.oneTimeInputChangedFunc} // duplicate is for part pay unified code with unpaid
                        onChanged={this.oneTimeInputChangedFunc} // duplicate is for check mark
                        onMethodChanged={this.oneTimePaymentMethodChangedFunc}
                        isViewedAsManager={this.props.isViewedAsManager}
                        // shouldHideCreditCardOption={this.props.shouldHideCreditCardOption}
                        buildingID={this.state.buildingID}
                        apartmentNumber={this.state.apartmentNumber}
                    />
                )
            })
        )
    }

    render() {

        BllinkLogger.info(`one time payments this state `, this.state);
        this.setBodyClasses(constants.backgroundOptions.oneTimeSelect);
        const hasPayments = (this.state.payments.length > 0)

        let payments;
        if (hasPayments) {
            payments = this.renderPayments()
        } else {
            payments = <AllPaid/>
        }

        return (
            <div id="jquery-one-time-box" className="col-md-12 ensure-height">
                <div className="row d-flex justify-content-center">
                    {payments}
                </div>

                {this.state.isManager && (
                    <AddFastPayment
                        buildingID={this.props.buildingID}
                        apartmentNumber={this.props.apartmentNumber}
                    />
                )}

                <BackNextBar
                    buildingID={this.props.buildingID}
                    apartmentNumber={this.props.apartmentNumber}
                    currentTab={constants.pages.oneTimeTab}
                    paymentsStats={this.props.paymentsStats}
                    onNextBackChange={this.props.onChangeNextBack}
                    isViewedAsManager={this.props.isViewedAsManager}
                    shouldHideCreditCardOption={this.props.shouldHideCreditCardOption}
                />
            </div>
        )

    }
}

export default withTranslation()(OneTimePaymentSection);
